module.exports = __webpack_public_path__ + "img/透明度演示.7d958b0e.gif";